import { gql } from '@apollo/client';

export const GET_RESULTS = gql`
  query GetResults($date: Date!, $trackId: ID) {
    results(date: $date, track_id: $trackId) {
      race_id
      race_number
      position
      horse_name
      jockey
      trainer
      weight
      barrier
      sp
      margin
    }
  }
`;

export const GET_RACE_RESULTS = gql`
  query GetRaceResults($date: Date!, $trackName: String!) {
    raceResults(date: $date, trackName: $trackName) {
      track {
        name
        state
        type
      }
      races {
        race_id
        race_number
        race_name
        distance
        class
        results {
          position
          horse_name
          jockey
          trainer
          weight
          barrier
          sp
          margin
        }
      }
      summary {
        totalRaces
        totalRunners
        favorites {
          wins
          places
          total
        }
        avgWinPrice
        avgPlacePrice
      }
    }
  }
`;
